var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.list.length > 0
    ? _c("div", { staticClass: "key_list" }, [
        _c("div", { staticClass: "key_list_tit" }, [
          _c("h3", [_vm._v("搜索历史")]),
          _vm._v(" "),
          _c("a", { staticClass: "tit_r", on: { click: _vm.clear } }, [
            _c("i", { staticClass: "icon_trash" }),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "ul",
          _vm._l(_vm.list, function (key, index) {
            return _c("li", { key: index }, [
              _c(
                "a",
                { attrs: { href: _vm._f("toSearchUrl")(key, _vm.spver) } },
                [_vm._v(_vm._s(key))]
              ),
            ])
          }),
          0
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }